import { css } from 'lit';

/**
 * CSS Custom Properties par défaut du composant. Toutes overridables depuis
 * l'app hôte via `sarah-bot { --sarah-rose: ...; }`.
 *
 * À inclure dans le `:host` de chaque composant Lit qui en a besoin via la
 * propriété `static styles` (ou de manière centralisée dans sarah-bot).
 *
 * Palette — usage attendu :
 *   --sarah-rose       : fond de boutons primaires, accents lourds (contraste
 *                        OK avec texte blanc sur le fond rose).
 *   --sarah-rose-dark  : textes accentués sur fond clair (sous-titres rose,
 *                        liens, bordures de bouton outline). Ratio ~6:1 sur
 *                        blanc = WCAG AA pour petits textes, AAA pour gros.
 *   --sarah-bleu       : fond/accent lourd, bordures focus.
 *   --sarah-bleu-dark  : textes sur fond clair quand --sarah-bleu est limite
 *                        pour le contraste (petits textes < 18px).
 */
export const tokens = css`
  :host {
    --sarah-rose: #c02b6b;
    --sarah-rose-hover: #d13377;
    --sarah-rose-dark: #a52055;
    --sarah-bleu: #355689;
    --sarah-bleu-hover: #2b4773;
    --sarah-bleu-dark: #284871;
    --sarah-text: #424242;
    --sarah-font-body: 'Nunito', system-ui, -apple-system, sans-serif;
    --sarah-font-display: 'Lato', system-ui, -apple-system, sans-serif;
    --sarah-radius: 15px;
    --sarah-radius-btn: 5px;
    --sarah-max-width: 800px;
    --sarah-disabled-bg: #eae9e3;
    --sarah-disabled-fg: #c0beb8;
    --sarah-border: #d6d4ce;
    --sarah-border-hover: #9b9995;
    --sarah-card-shadow: 0 1px 11px 2px rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.06);
    --sarah-error: #b30000;
    --sarah-tap-min: 44px;
  }
`;
